import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useIntegrationContext } from '../../IntegrationProvider';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Property from '@afosto/app-components-react/Property';
import isDefined from '@afosto/utils/isDefined';
import {
  boolean as booleanFormatter,
  datetime as datetimeFormatter,
} from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';

const IntegrationInformation = () => {
  const intl = useIntl();
  const { integration } = useIntegrationContext();

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <Box px={2} pb={2}>
        <Property
          label={intl.formatMessage(translations.properties.name)}
          value={integration?.name}
        />
        <Property
          label={intl.formatMessage(translations.properties.isInstalled)}
          value={
            isDefined(integration?.is_installed)
              ? booleanFormatter(integration.is_installed)
              : undefined
          }
        />
        <Property
          label={intl.formatMessage(translations.properties.activeAt)}
          value={
            isDefined(integration?.active_at) ? datetimeFormatter(integration.active_at) : undefined
          }
        />
        <Property
          label={intl.formatMessage(translations.properties.createdAt)}
          value={
            isDefined(integration?.created_at)
              ? datetimeFormatter(integration.created_at)
              : undefined
          }
        />
        <Property
          label={intl.formatMessage(translations.properties.updatedAt)}
          value={
            isDefined(integration?.updated_at)
              ? datetimeFormatter(integration.updated_at)
              : undefined
          }
        />
      </Box>
    </Card>
  );
};

export default IntegrationInformation;
